import { useEffect, useState, useRef } from "react";
import { verPDF } from "../pdfViewer";

const API = "/api";
const token = () => localStorage.getItem("token");

const colores: any = { pendiente: "#3b82f6", abonado: "#f59e0b", pagado: "#22c55e", atrasado: "#ef4444" };
const coloresClasificacion: any = { A: "#22c55e", B: "#f59e0b", C: "#ef4444" };
const nombreClasificacion: any = { A: "Paga a tiempo", B: "Paga un poco tarde", C: "Se atrasa mucho" };

export default function Creditos() {
  const [ventas, setVentas] = useState<any[]>([]);
  const [morosos, setMorosos] = useState<any[]>([]);
  const [papelera, setPapelera] = useState<any[]>([]);
  const [vista, setVista] = useState<"todas" | "morosos" | "papelera">("todas");
  const [filtroEstado, setFiltroEstado] = useState("");
  const [detalleId, setDetalleId] = useState<number | null>(null);
  const [detalle, setDetalle] = useState<any>(null);
  const [abonoForm, setAbonoForm] = useState({ monto: "", metodo_pago: "efectivo", notas: "" });
  const [enviando, setEnviando] = useState(false);
  const [clasificaciones, setClasificaciones] = useState<Record<string, any>>({});

  // Edición de venta
  const [editandoVenta, setEditandoVenta] = useState(false);
  const [carritoEdit, setCarritoEdit] = useState<any[]>([]);
  const [productos, setProductos] = useState<any[]>([]);
  const [busquedaEdit, setBusquedaEdit] = useState("");

  // Edición del abono más reciente
  const [editandoAbonoId, setEditandoAbonoId] = useState<number | null>(null);
  const detalleRef = useRef<HTMLDivElement>(null);
  const [abonoEditForm, setAbonoEditForm] = useState({ monto: "", metodo_pago: "efectivo", notas: "" });
  const [clienteExpandido, setClienteExpandido] = useState<string | null>(null);
  const [busquedaCliente, setBusquedaCliente] = useState("");
  const [mostrarSugerenciasCliente, setMostrarSugerenciasCliente] = useState(false);

  const cargarVentas = () => {
    const qs = filtroEstado ? `?estado=${filtroEstado}` : "";
    fetch(`${API}/creditos/ventas${qs}`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => Array.isArray(d) && setVentas(d)).catch(() => {});
  };
  const cargarMorosos = () => {
    fetch(`${API}/creditos/ventas/morosos`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => Array.isArray(d) && setMorosos(d)).catch(() => {});
  };
  const cargarClasificaciones = () => {
    fetch(`${API}/creditos/clientes/clasificacion`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => d && typeof d === "object" && setClasificaciones(d)).catch(() => {});
  };
  const cargarPapelera = () => {
    fetch(`${API}/creditos/ventas/papelera`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => Array.isArray(d) && setPapelera(d)).catch(() => {});
  };

  useEffect(() => {
    cargarVentas(); cargarMorosos(); cargarClasificaciones(); cargarPapelera();
    setClienteExpandido(null);
  }, [filtroEstado, vista]);

  const abrirDetalle = (id: number) => {
    setDetalleId(id);
    setAbonoForm({ monto: "", metodo_pago: "efectivo", notas: "" });
    setEditandoVenta(false);
    setEditandoAbonoId(null);
    fetch(`${API}/creditos/ventas/${id}`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => {
        setDetalle(d);
        setTimeout(() => {
          if (window.innerWidth <= 768) {
            detalleRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 100);
      }).catch(() => {});
  };

  const registrarAbono = async () => {
    if (!detalleId || !abonoForm.monto) return;
    setEnviando(true);
    const r = await fetch(`${API}/creditos/ventas/${detalleId}/abonos`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ ...abonoForm, monto: Number(abonoForm.monto) }),
    });
    setEnviando(false);
    if (r.ok) {
      abrirDetalle(detalleId);
      cargarVentas();
      cargarMorosos();
      cargarClasificaciones();
      setAbonoForm({ monto: "", metodo_pago: "efectivo", notas: "" });
    } else {
      const err = await r.json().catch(() => ({}));
      alert("Error: " + (err.detail || "no se pudo registrar el abono"));
    }
  };

  const eliminarVenta = async () => {
    if (!detalle) return;
    if (!window.confirm(`¿Mandar la venta #${detalle.id} de ${detalle.cliente} a la papelera? Queda guardada completa (con sus abonos) por 30 días, y se puede restaurar en cualquier momento desde ahí.`)) return;
    const r = await fetch(`${API}/creditos/ventas/${detalle.id}`, {
      method: "DELETE", headers: { Authorization: `Bearer ${token()}` },
    });
    if (r.ok) {
      setDetalleId(null); setDetalle(null);
      cargarVentas(); cargarMorosos(); cargarClasificaciones(); cargarPapelera();
    } else {
      const err = await r.json().catch(() => ({}));
      alert("Error: " + (err.detail || "no se pudo eliminar"));
    }
  };

  const restaurarVenta = async (id: number) => {
    if (!window.confirm(`¿Restaurar la venta #${id}? Vuelve a aparecer normal, tal como estaba.`)) return;
    const r = await fetch(`${API}/creditos/ventas/${id}/restaurar`, {
      method: "POST", headers: { Authorization: `Bearer ${token()}` },
    });
    if (r.ok) {
      cargarPapelera(); cargarVentas(); cargarMorosos(); cargarClasificaciones();
    } else {
      const err = await r.json().catch(() => ({}));
      alert("Error: " + (err.detail || "no se pudo restaurar"));
    }
  };

  const purgarVenta = async (id: number) => {
    if (!window.confirm(`¿Borrar la venta #${id} EN DEFINITIVO? Esta acción ya no se puede deshacer -- se pierde para siempre.`)) return;
    const r = await fetch(`${API}/creditos/ventas/${id}/purgar`, {
      method: "DELETE", headers: { Authorization: `Bearer ${token()}` },
    });
    if (r.ok) {
      cargarPapelera();
    } else {
      const err = await r.json().catch(() => ({}));
      alert("Error: " + (err.detail || "no se pudo purgar"));
    }
  };

  const abrirEdicionVenta = () => {
    if (!detalle) return;
    setCarritoEdit(detalle.productos.map((p: any, i: number) => ({
      key: p.producto_id ? `p-${p.producto_id}` : `c-${i}`,
      producto_id: p.producto_id || null,
      nombre: p.nombre, descripcion: p.descripcion, imagen_url: p.imagen_url,
      precio: p.precio_unitario, cantidad: p.cantidad, esCustom: !p.producto_id,
    })));
    fetch(`${API}/productos/`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => Array.isArray(d) && setProductos(d)).catch(() => {});
    setEditandoVenta(true);
  };
  const productosFiltradosEdit = productos.filter(p => p.nombre.toLowerCase().includes(busquedaEdit.toLowerCase())).slice(0, 8);
  const agregarProductoEdit = (p: any) => {
    const existente = carritoEdit.find(i => i.producto_id === p.id);
    if (existente) {
      setCarritoEdit(carritoEdit.map(i => i.producto_id === p.id ? { ...i, cantidad: i.cantidad + 1 } : i));
    } else {
      setCarritoEdit([...carritoEdit, { key: `p-${p.id}`, producto_id: p.id, nombre: p.nombre, precio: p.precio_oferta || p.precio, cantidad: 1, esCustom: false }]);
    }
    setBusquedaEdit("");
  };
  const cambiarCantidadEdit = (key: string, cantidad: number) =>
    setCarritoEdit(carritoEdit.map(i => i.key === key ? { ...i, cantidad: Math.max(1, cantidad) } : i));
  const quitarEdit = (key: string) => setCarritoEdit(carritoEdit.filter(i => i.key !== key));
  const totalEdit = carritoEdit.reduce((s, i) => s + i.precio * i.cantidad, 0);
  const guardarEdicionVenta = async () => {
    if (!detalle || carritoEdit.length === 0) return;
    setEnviando(true);
    const items = carritoEdit.map(i => i.esCustom ? {
      producto_id: null, nombre_personalizado: i.nombre, descripcion: i.descripcion || null,
      precio_unitario: i.precio, imagen_url: i.imagen_url || null, cantidad: i.cantidad,
    } : { producto_id: i.producto_id, cantidad: i.cantidad });
    const r = await fetch(`${API}/creditos/ventas/${detalle.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ cliente_id: detalle.cliente_id, vendedor_id: detalle.vendedor_id, items, notas: detalle.notas || null }),
    });
    setEnviando(false);
    if (r.ok) {
      setEditandoVenta(false);
      abrirDetalle(detalle.id);
      cargarVentas(); cargarMorosos(); cargarClasificaciones();
    } else {
      const err = await r.json().catch(() => ({}));
      alert("Error: " + (err.detail || "no se pudo guardar"));
    }
  };
  const abrirEdicionAbono = (a: any) => {
    setEditandoAbonoId(a.id);
    setAbonoEditForm({ monto: String(a.monto), metodo_pago: a.metodo_pago, notas: "" });
  };
  const guardarEdicionAbono = async () => {
    if (!editandoAbonoId || !abonoEditForm.monto) return;
    setEnviando(true);
    const r = await fetch(`${API}/creditos/abonos/${editandoAbonoId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ ...abonoEditForm, monto: Number(abonoEditForm.monto) }),
    });
    setEnviando(false);
    if (r.ok) {
      setEditandoAbonoId(null);
      abrirDetalle(detalleId!);
      cargarVentas(); cargarMorosos(); cargarClasificaciones();
    } else {
      const err = await r.json().catch(() => ({}));
      alert("Error: " + (err.detail || "no se pudo editar el abono"));
    }
  };
  const eliminarAbono = async (a: any) => {
    if (!window.confirm(`¿Eliminar este abono de ₡${a.monto?.toLocaleString()}?`)) return;
    const r = await fetch(`${API}/creditos/abonos/${a.id}`, {
      method: "DELETE", headers: { Authorization: `Bearer ${token()}` },
    });
    if (r.ok) {
      abrirDetalle(detalleId!);
      cargarVentas(); cargarMorosos(); cargarClasificaciones();
    } else {
      const err = await r.json().catch(() => ({}));
      alert("Error: " + (err.detail || "no se pudo eliminar"));
    }
  };
  const lista = vista === "morosos" ? morosos : vista === "papelera" ? [] : ventas;

  // Agrupamos por cliente (usando cliente_id si viene, o el nombre como respaldo
  // para la vista de morosos, que no siempre trae el id numérico)
  const grupos = lista.reduce((acc: any, v: any) => {
    const key = String(v.cliente_id ?? v.cliente);
    if (!acc[key]) acc[key] = { cliente: v.cliente, telefono: v.telefono, ventas: [] };
    acc[key].ventas.push(v);
    return acc;
  }, {} as Record<string, any>);

  const gruposArrayCompleto = Object.entries(grupos).map(([key, g]: [string, any]) => ({
    key,
    cliente: g.cliente,
    telefono: g.telefono,
    ventas: g.ventas,
    saldoTotal: g.ventas.reduce((s: number, v: any) => s + (v.saldo_pendiente || 0), 0),
  })).sort((a, b) => b.saldoTotal - a.saldoTotal);

  const gruposArray = busquedaCliente.trim()
    ? gruposArrayCompleto.filter(g => g.cliente?.toLowerCase().includes(busquedaCliente.trim().toLowerCase()))
    : gruposArrayCompleto;

  const sugerenciasCliente = busquedaCliente.trim()
    ? gruposArrayCompleto
        .filter(g => g.cliente?.toLowerCase().includes(busquedaCliente.trim().toLowerCase()))
        .slice(0, 5)
    : [];

  const input = { padding: "10px 12px", borderRadius: "10px", border: "1.5px solid #e5e7eb", fontSize: "14px", fontFamily: "Nunito,sans-serif" };

  return (
    <div>
      <h1 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "24px", fontWeight: 900, marginBottom: "20px", color: "#1a1a2e" }}>
        Créditos
      </h1>

      <div style={{ display: "flex", gap: "10px", marginBottom: "12px", flexWrap: "wrap" }}>
        <button onClick={() => setVista("todas")}
          style={{ background: vista === "todas" ? "#0D47A1" : "#fff", color: vista === "todas" ? "#fff" : "#374151", border: "1.5px solid #e5e7eb", borderRadius: "10px", padding: "8px 16px", fontWeight: 700, cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
          Todas las ventas
        </button>
        <button onClick={() => setVista("morosos")}
          style={{ background: vista === "morosos" ? "#ef4444" : "#fff", color: vista === "morosos" ? "#fff" : "#374151", border: "1.5px solid #e5e7eb", borderRadius: "10px", padding: "8px 16px", fontWeight: 700, cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
          🔴 Morosos ({morosos.length})
        </button>
        <button onClick={() => setVista("papelera")}
          style={{ background: vista === "papelera" ? "#6b7280" : "#fff", color: vista === "papelera" ? "#fff" : "#374151", border: "1.5px solid #e5e7eb", borderRadius: "10px", padding: "8px 16px", fontWeight: 700, cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
          🗑️ Papelera ({papelera.length})
        </button>
        {vista === "todas" && (
          <select style={input} value={filtroEstado} onChange={e => setFiltroEstado(e.target.value)}>
            <option value="">Todos los estados</option>
            <option value="pendiente">Pendiente</option>
            <option value="abonado">Abonado</option>
            <option value="pagado">Pagado</option>
            <option value="atrasado">Atrasado</option>
          </select>
        )}
      </div>

      {vista !== "papelera" && (
        <div style={{ display: "flex", gap: "14px", flexWrap: "wrap", marginBottom: "20px", fontSize: "12px", color: "#6b7280", fontFamily: "Nunito,sans-serif" }}>
          <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <span style={{ width: "10px", height: "10px", borderRadius: "50%", background: coloresClasificacion.A, display: "inline-block" }} />
            A — paga a tiempo
          </span>
          <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <span style={{ width: "10px", height: "10px", borderRadius: "50%", background: coloresClasificacion.B, display: "inline-block" }} />
            B — paga un poco tarde
          </span>
          <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <span style={{ width: "10px", height: "10px", borderRadius: "50%", background: coloresClasificacion.C, display: "inline-block" }} />
            C — se atrasa mucho
          </span>
        </div>
      )}

      {vista !== "papelera" && (
        <div style={{ position: "relative", width: "100%", maxWidth: "360px", marginBottom: "20px" }}>
          <input
            type="text"
            placeholder="Buscar cliente..."
            value={busquedaCliente}
            onChange={e => setBusquedaCliente(e.target.value)}
            onFocus={() => setMostrarSugerenciasCliente(true)}
            onBlur={() => setTimeout(() => setMostrarSugerenciasCliente(false), 150)}
            style={{
              width: "100%", padding: "10px 14px", borderRadius: "10px",
              border: "1.5px solid #e5e7eb", fontSize: "14px", fontFamily: "Nunito,sans-serif",
              boxSizing: "border-box",
            }}
          />
          {mostrarSugerenciasCliente && sugerenciasCliente.length > 0 && (
            <div style={{
              position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, zIndex: 10,
              background: "#fff", borderRadius: "10px", border: "1.5px solid #e5e7eb",
              boxShadow: "0 4px 16px rgba(0,0,0,0.08)", overflow: "hidden",
            }}>
              {sugerenciasCliente.map(g => (
                <div
                  key={g.key}
                  onMouseDown={() => { setBusquedaCliente(g.cliente); setMostrarSugerenciasCliente(false); setClienteExpandido(g.key); }}
                  style={{
                    padding: "10px 14px", fontSize: "14px", fontFamily: "Nunito,sans-serif",
                    cursor: "pointer", borderBottom: "1px solid #f3f4f6",
                    display: "flex", justifyContent: "space-between",
                  }}
                  onMouseEnter={e => (e.currentTarget.style.background = "#F0F7FF")}
                  onMouseLeave={e => (e.currentTarget.style.background = "#fff")}
                >
                  <span style={{ fontWeight: 700 }}>{g.cliente}</span>
                  <span style={{ color: "#ef4444", fontWeight: 700 }}>₡{g.saldoTotal.toLocaleString()}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .creditos-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>

      {vista === "papelera" ? (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px" }}>
            Lo que está acá se guarda completo (con sus abonos) por 30 días desde que se eliminó, y después se borra en definitivo automáticamente. Se puede restaurar en cualquier momento antes de eso.
          </div>
          {papelera.map(v => (
            <div key={v.id} style={{ background: "#fff", borderRadius: "16px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", padding: "16px 20px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px", borderLeft: "5px solid #6b7280" }}>
              <div>
                <div style={{ fontWeight: 800, fontSize: "15px" }}>Venta #{v.id} — {v.cliente}</div>
                <div style={{ fontSize: "12px", color: "#9ca3af" }}>
                  Eliminada el {v.eliminado_en ? new Date(v.eliminado_en).toLocaleDateString() : "-"} por {v.eliminado_por || "desconocido"}
                </div>
                <div style={{ fontSize: "12px", color: v.dias_restantes <= 5 ? "#ef4444" : "#9ca3af", fontWeight: v.dias_restantes <= 5 ? 700 : 400 }}>
                  {v.dias_restantes > 0 ? `Se purga en definitivo en ${v.dias_restantes} día${v.dias_restantes !== 1 ? "s" : ""}` : "Se purgará muy pronto (automático)"}
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontFamily: "Montserrat,sans-serif", fontWeight: 900, fontSize: "16px", color: "#374151" }}>
                    ₡{v.total?.toLocaleString()}
                  </div>
                  <div style={{ fontSize: "10.5px", color: "#9ca3af" }}>total de la venta</div>
                </div>
                <button onClick={() => restaurarVenta(v.id)}
                  style={{ fontSize: "12px", fontWeight: 700, color: "#166534", background: "#F0FDF4", border: "none", borderRadius: "8px", padding: "8px 14px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
                  ♻️ Restaurar
                </button>
                <button onClick={() => purgarVenta(v.id)}
                  style={{ fontSize: "12px", fontWeight: 700, color: "#991B1B", background: "#FEF2F2", border: "none", borderRadius: "8px", padding: "8px 14px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
                  ⚠️ Purgar ahora
                </button>
              </div>
            </div>
          ))}
          {papelera.length === 0 && (
            <div style={{ textAlign: "center", padding: "60px", color: "#9ca3af", background: "#fff", borderRadius: "16px" }}>
              La papelera está vacía 🎉
            </div>
          )}
        </div>
      ) : (
      <div className="creditos-grid" style={{ display: "grid", gridTemplateColumns: detalleId ? "1fr 1fr" : "1fr", gap: "20px" }}>
        {/* Listado agrupado por cliente */}
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {gruposArray.map(g => {
            const abierto = clienteExpandido === g.key;
            const clasif = clasificaciones[g.key];
            const colorBorde = clasif ? coloresClasificacion[clasif.clasificacion] : "transparent";
            return (
              <div key={g.key} style={{ background: "#fff", borderRadius: "16px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", overflow: "hidden", borderLeft: `5px solid ${colorBorde}` }}>
                <div onClick={() => setClienteExpandido(abierto ? null : g.key)}
                  style={{ padding: "16px 20px", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
                  <div>
                    <div style={{ fontWeight: 800, fontSize: "15px", display: "flex", alignItems: "center", gap: "8px" }}>
                      {g.cliente} {g.telefono && `· 📞 ${g.telefono}`}
                      {clasif && (
                        <span
                          title={`${nombreClasificacion[clasif.clasificacion]} — en promedio paga ${clasif.promedio_dias_atraso} día(s) después del corte (${clasif.ventas_consideradas} venta${clasif.ventas_consideradas !== 1 ? "s" : ""} saldada${clasif.ventas_consideradas !== 1 ? "s" : ""})`}
                          style={{
                            display: "inline-flex", alignItems: "center", justifyContent: "center",
                            width: "20px", height: "20px", borderRadius: "50%",
                            background: colorBorde, color: "#fff", fontSize: "10.5px", fontWeight: 800,
                            fontFamily: "Nunito,sans-serif", flexShrink: 0,
                          }}>
                          {clasif.clasificacion}
                        </span>
                      )}
                    </div>
                    <div style={{ fontSize: "12px", color: "#9ca3af" }}>{g.ventas.length} factura{g.ventas.length !== 1 ? "s" : ""}</div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                    <div style={{ textAlign: "right" }}>
                      <div style={{ fontFamily: "Montserrat,sans-serif", fontWeight: 900, fontSize: "17px", color: "#ef4444" }}>
                        ₡{g.saldoTotal.toLocaleString()}
                      </div>
                      <div style={{ fontSize: "10.5px", color: "#9ca3af" }}>saldo total</div>
                    </div>
                    <span style={{ fontSize: "18px", color: "#9ca3af", display: "inline-block", transform: abierto ? "rotate(180deg)" : "none", transition: "transform .2s ease" }}>⌄</span>
                  </div>
                </div>

                {abierto && (
                  <div style={{ borderTop: "1px solid #f3f4f6" }}>
                    {g.ventas.map((v: any) => (
                      <div key={v.id || v.venta_id} onClick={() => abrirDetalle(v.id || v.venta_id)}
                        style={{ padding: "12px 20px 12px 32px", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px", borderLeft: `4px solid ${colores[v.estado] || "#ef4444"}`, background: "#FAFAFA", borderTop: "1px solid #f3f4f6" }}>
                        <div style={{ fontSize: "13px", color: "#374151" }}>
                          {v.dias_atraso !== undefined
                            ? `⚠️ ${v.dias_atraso} día${v.dias_atraso !== 1 ? "s" : ""} de atraso`
                            : `Factura #${v.id} · ${new Date(v.fecha_venta).toLocaleDateString()}`}
                        </div>
                        <div style={{ textAlign: "right" }}>
                          <span style={{ fontWeight: 800, fontSize: "14px", color: "#ef4444" }}>₡{v.saldo_pendiente?.toLocaleString()}</span>
                          {v.estado && (
                            <span style={{ marginLeft: "8px", fontSize: "10.5px", fontWeight: 700, color: colores[v.estado], textTransform: "uppercase" }}>{v.estado}</span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
          {gruposArray.length === 0 && (
            <div style={{ textAlign: "center", padding: "60px", color: "#9ca3af", background: "#fff", borderRadius: "16px" }}>
              {vista === "morosos" ? "No hay clientes morosos 🎉" : "No hay ventas a crédito"}
            </div>
          )}
        </div>

        {/* Detalle + abono */}
        {detalleId && detalle && (
          <div ref={detalleRef} style={{ background: "#fff", borderRadius: "16px", padding: "20px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", alignSelf: "start" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
              <div style={{ fontWeight: 800, fontSize: "16px" }}>Venta #{detalle.id} — {detalle.cliente}</div>
              <button onClick={() => setDetalleId(null)} style={{ background: "none", border: "none", fontSize: "20px", cursor: "pointer", color: "#9ca3af" }}>×</button>
            </div>

            {!editandoVenta && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
                <button onClick={abrirEdicionVenta}
                  style={{ fontSize: "12px", fontWeight: 700, color: "#1565C0", background: "#EFF6FF", border: "none", borderRadius: "8px", padding: "6px 12px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
                  ✏️ Editar venta
                </button>
                <button onClick={eliminarVenta}
                  style={{ fontSize: "12px", fontWeight: 700, color: "#991B1B", background: "#FEF2F2", border: "none", borderRadius: "8px", padding: "6px 12px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
                  🗑️ Eliminar venta
                </button>
              </div>
            )}

            {editandoVenta ? (
              <div style={{ background: "#FFFBEB", borderRadius: "12px", padding: "14px", marginBottom: "12px" }}>
                <div style={{ fontWeight: 700, fontSize: "13px", marginBottom: "8px" }}>Editando productos de la venta</div>
                <input placeholder="Buscar producto del catálogo..." value={busquedaEdit}
                  onChange={e => setBusquedaEdit(e.target.value)}
                  style={{ ...input, width: "100%", boxSizing: "border-box", marginBottom: "8px" }} />
                {busquedaEdit && (
                  <div style={{ marginBottom: "8px", display: "flex", flexDirection: "column", gap: "4px" }}>
                    {productosFiltradosEdit.map(p => (
                      <div key={p.id} onClick={() => agregarProductoEdit(p)}
                        style={{ padding: "8px 10px", background: "#fff", borderRadius: "8px", cursor: "pointer", display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                        <span>{p.nombre}</span><span style={{ color: "#6b7280" }}>₡{(p.precio_oferta || p.precio)?.toLocaleString()} · stock {p.stock}</span>
                      </div>
                    ))}
                  </div>
                )}
                <div style={{ display: "flex", flexDirection: "column", gap: "6px", marginBottom: "10px" }}>
                  {carritoEdit.map(i => (
                    <div key={i.key} style={{ display: "flex", alignItems: "center", gap: "6px", background: "#fff", padding: "8px", borderRadius: "8px" }}>
                      <div style={{ flex: 1, fontSize: "13px" }}>{i.nombre}</div>
                      <input type="number" min={1} value={i.cantidad}
                        onChange={e => cambiarCantidadEdit(i.key, Number(e.target.value))}
                        style={{ width: "44px", padding: "4px", borderRadius: "6px", border: "1px solid #e5e7eb", textAlign: "center" }} />
                      <div style={{ fontSize: "12px", fontWeight: 700, width: "70px", textAlign: "right" }}>₡{(i.precio * i.cantidad).toLocaleString()}</div>
                      <button onClick={() => quitarEdit(i.key)} style={{ background: "none", border: "none", color: "#ef4444", fontSize: "16px", cursor: "pointer" }}>×</button>
                    </div>
                  ))}
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 800, marginBottom: "10px" }}>
                  <span>Nuevo total</span><span>₡{totalEdit.toLocaleString()}</span>
                </div>
                <div style={{ display: "flex", gap: "8px" }}>
                  <button onClick={guardarEdicionVenta} disabled={enviando || carritoEdit.length === 0}
                    style={{ flex: 1, background: "#0D47A1", color: "#fff", border: "none", borderRadius: "8px", padding: "10px", fontWeight: 800, cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
                    {enviando ? "Guardando..." : "Guardar cambios"}
                  </button>
                  <button onClick={() => setEditandoVenta(false)}
                    style={{ background: "#fff", color: "#6b7280", border: "1.5px solid #e5e7eb", borderRadius: "8px", padding: "10px 16px", fontWeight: 700, cursor: "pointer" }}>
                    Cancelar
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div style={{ fontSize: "13px", color: "#6b7280", marginBottom: "12px" }}>
                  {detalle.productos?.map((p: any, i: number) => (
                    <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0" }}>
                      <span>{p.nombre} x{p.cantidad}</span>
                      <span>₡{p.subtotal?.toLocaleString()}</span>
                    </div>
                  ))}
                </div>

                {detalle.costo_envio > 0 && (
                  <>
                    <div style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", borderTop: "1px solid #f3f4f6", fontSize: "13px", color: "#6b7280" }}>
                      <span>Subtotal productos</span><span>₡{detalle.subtotal_productos?.toLocaleString()}</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "13px", color: "#6b7280" }}>
                      <span>🚚 Costo de envío</span><span>₡{detalle.costo_envio?.toLocaleString()}</span>
                    </div>
                  </>
                )}
                <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderTop: detalle.costo_envio > 0 ? "none" : "1px solid #f3f4f6", fontWeight: 700 }}>
                  <span>Total</span><span>₡{detalle.total?.toLocaleString()}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontWeight: 800, color: "#ef4444" }}>
                  <span>Saldo pendiente</span><span>₡{detalle.saldo_pendiente?.toLocaleString()}</span>
                </div>
              </>
            )}

            <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
              <button onClick={() => verPDF(`${API}/creditos/ventas/${detalle.id}/recibo-pdf`, `recibo_credito_${detalle.cliente.replace(/[^\\w\\s-]/g, "").trim().replace(/\\s+/g, "_").slice(0,40) || "cliente"}_${detalle.id}.pdf`)}
                style={{ fontSize: "13px", color: "#1565C0", fontWeight: 700, background: "none", border: "none", cursor: "pointer", padding: 0, fontFamily: "Nunito,sans-serif" }}>
                📄 Recibo (carta)
              </button>
              <button onClick={() => verPDF(`${API}/creditos/ventas/${detalle.id}/recibo-pdf?formato=ticket`, `recibo_credito_${detalle.cliente.replace(/[^\\w\\s-]/g, "").trim().replace(/\\s+/g, "_").slice(0,40) || "cliente"}_${detalle.id}_ticket.pdf`)}
                style={{ fontSize: "13px", color: "#C2410C", fontWeight: 700, background: "none", border: "none", cursor: "pointer", padding: 0, fontFamily: "Nunito,sans-serif" }}>
                🧾 Recibo (ticket)
              </button>
            </div>

            <div style={{ fontWeight: 700, fontSize: "14px", marginTop: "20px", marginBottom: "8px" }}>Historial de abonos</div>
            <div style={{ display: "flex", flexDirection: "column", gap: "6px", marginBottom: "16px" }}>
              {detalle.abonos?.map((a: any, idx: number) => {
                const esUltimo = idx === detalle.abonos.length - 1;
                if (editandoAbonoId === a.id) {
                  return (
                    <div key={a.id} style={{ background: "#FFFBEB", padding: "10px", borderRadius: "8px" }}>
                      <input type="number" placeholder="Monto" value={abonoEditForm.monto}
                        onChange={e => setAbonoEditForm({ ...abonoEditForm, monto: e.target.value })}
                        style={{ ...input, width: "100%", boxSizing: "border-box", marginBottom: "6px" }} />
                      <select value={abonoEditForm.metodo_pago} onChange={e => setAbonoEditForm({ ...abonoEditForm, metodo_pago: e.target.value })}
                        style={{ ...input, width: "100%", boxSizing: "border-box", marginBottom: "6px" }}>
                        <option value="efectivo">Efectivo</option>
                        <option value="sinpe">Sinpe Móvil</option>
                        <option value="transferencia">Transferencia</option>
                        <option value="tarjeta">Tarjeta</option>
                      </select>
                      <div style={{ display: "flex", gap: "6px" }}>
                        <button onClick={guardarEdicionAbono} disabled={enviando}
                          style={{ flex: 1, background: "#0D47A1", color: "#fff", border: "none", borderRadius: "6px", padding: "8px", fontWeight: 700, fontSize: "13px", cursor: "pointer" }}>
                          Guardar
                        </button>
                        <button onClick={() => setEditandoAbonoId(null)}
                          style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: "6px", padding: "8px 12px", fontSize: "13px", cursor: "pointer" }}>
                          Cancelar
                        </button>
                      </div>
                    </div>
                  );
                }
                return (
                  <div key={a.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: "#F9FAFB", padding: "8px 12px", borderRadius: "8px", fontSize: "13px" }}>
                    <span>
                      {new Date(a.fecha_abono).toLocaleDateString()} · {a.metodo_pago}
                      {a.saldo_despues != null && <span style={{ color: "#9ca3af", marginLeft: "6px" }}>· saldo tras esto: ₡{a.saldo_despues.toLocaleString()}</span>}
                    </span>
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <span style={{ fontWeight: 700, color: "#22c55e" }}>₡{a.monto?.toLocaleString()}</span>
                      <button onClick={() => verPDF(`${API}/creditos/abonos/${a.id}/recibo-pdf`, `abono_${a.id}.pdf`)}
                        style={{ background: "none", border: "none", cursor: "pointer", fontSize: "13px" }} title="Recibo carta">
                        📄
                      </button>
                      <button onClick={() => verPDF(`${API}/creditos/abonos/${a.id}/recibo-pdf?formato=ticket`, `abono_${a.id}_ticket.pdf`)}
                        style={{ background: "none", border: "none", cursor: "pointer", fontSize: "13px" }} title="Recibo ticket">
                        🧾
                      </button>
                      {esUltimo && (
                        <>
                          <button onClick={() => abrirEdicionAbono(a)}
                            style={{ background: "none", border: "none", cursor: "pointer", fontSize: "13px" }} title="Editar (solo el más reciente)">
                            ✏️
                          </button>
                          <button onClick={() => eliminarAbono(a)}
                            style={{ background: "none", border: "none", cursor: "pointer", fontSize: "13px" }} title="Eliminar (solo el más reciente)">
                            🗑️
                          </button>
                        </>
                      )}
                    </span>
                  </div>
                );
              })}
              {(!detalle.abonos || detalle.abonos.length === 0) && <div style={{ color: "#9ca3af", fontSize: "13px" }}>Sin abonos aún</div>}
            </div>

            {detalle.saldo_pendiente > 0 && (
              <div style={{ background: "#F9FAFB", borderRadius: "12px", padding: "14px" }}>
                <div style={{ fontWeight: 700, fontSize: "13px", marginBottom: "8px" }}>Registrar abono</div>
                <input type="number" placeholder="Monto" value={abonoForm.monto}
                  onChange={e => setAbonoForm({ ...abonoForm, monto: e.target.value })}
                  style={{ ...input, width: "100%", boxSizing: "border-box", marginBottom: "8px" }} />
                <select value={abonoForm.metodo_pago} onChange={e => setAbonoForm({ ...abonoForm, metodo_pago: e.target.value })}
                  style={{ ...input, width: "100%", boxSizing: "border-box", marginBottom: "8px" }}>
                  <option value="efectivo">Efectivo</option>
                  <option value="sinpe">Sinpe Móvil</option>
                  <option value="transferencia">Transferencia</option>
                  <option value="tarjeta">Tarjeta</option>
                </select>
                <button onClick={registrarAbono} disabled={!abonoForm.monto || enviando}
                  style={{ width: "100%", background: "#22c55e", color: "#fff", border: "none", borderRadius: "10px", padding: "10px", fontWeight: 800, cursor: abonoForm.monto ? "pointer" : "not-allowed", opacity: abonoForm.monto ? 1 : 0.5, fontFamily: "Nunito,sans-serif" }}>
                  {enviando ? "Guardando..." : "Registrar abono"}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
      )}
    </div>
  );
}
